var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiClothes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ai_clothes__prefix__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ai_clothes__prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.327 8.692V5.649l1.807 1.084q.096.058.186.036.067-.016.101-.08.373-.694.778-1.565.072-.155-.054-.275l-1.82-1.73q-.116-.11-.291-.056-1.91.587-3.648.566l-.671-.008a.751.751 0 01-.1.008q-1.739.02-3.649-.566-.175-.054-.29.056l-1.82 1.73q-.127.12-.055.275.405.87.778 1.565.034.064.1.08.091.022.187-.036L4.673 5.65v7.198q0 .103.073.176.074.074.177.074h2.34a.75.75 0 010 1.5h-2.34q-.725 0-1.237-.513-.513-.512-.513-1.237V8.22q-.408.11-.842.007-.722-.173-1.074-.83Q.864 6.666.44 5.756q-.526-1.132.38-1.994l1.821-1.73q.751-.714 1.765-.403 1.686.518 3.19.5h.008a.75.75 0 01.049.002V2.12l.75.009q1.503.018 3.19-.5 1.013-.311 1.764.403l1.82 1.73q.907.862.381 1.994-.423.91-.816 1.642-.352.657-1.074.83-.434.104-.842-.007v.47a.75.75 0 01-1.5 0zm-.89-.002a.344.344 0 00-.32.218l-.71 1.806a.344.344 0 01-.192.194l-1.807.71a.344.344 0 000 .64l1.807.71a.343.343 0 01.193.194l.71 1.806a.344.344 0 00.64 0l.71-1.806a.343.343 0 01.193-.194l1.807-.71a.344.344 0 000-.64l-1.806-.71a.344.344 0 01-.195-.194l-.71-1.806a.344.344 0 00-.32-.218z",
    fillRule: "evenodd",
    fill: "#414751"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiClothes);
export default __webpack_public_path__ + "static/media/ai-clothes.50fb5a581feeaf4c18875675fda32c0d.svg";
export { ForwardRef as ReactComponent };